import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ListaAlarmas from "./components/ListaAlarmas";
import ListaContactos from "./components/ListaContactos";
import ListaContactosGenerales from "./components/ListaContactosGenerales";
import PanelAlarmas from "./components/PanelAlarmas";
import DashboardAlarmas from "./components/DashboardAlarmas";
import HMIAlarmas from "./components/HMIAlarmas";
import HistorialLlamadas from "./pages/HistorialLlamadas";
import LogAlarmas from "./pages/LogAlarmas";  // 🔹 Importar el nuevo componente

import "./index.css";
import "./App.css";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <Router> {/* ✅ Único <Router> en la aplicación */}
      <Routes>
        {/* Página de Login */}
        <Route path="/login" element={<Login onLogin={handleLogin} />} />

        {/* Rutas protegidas dentro del Layout */}
        {user ? (
          <Route path="/" element={<Layout user={user} onLogout={handleLogout} />}>
            <Route index element={<HMIAlarmas />} />
            <Route path="contactos" element={<ListaContactos />} />
            <Route path="contactos-generales" element={<ListaContactosGenerales />} />
            <Route path="Listado-alarmas" element={<ListaAlarmas />} />
            <Route path="dashboard" element={<DashboardAlarmas />} />
            <Route path="Panel" element={<PanelAlarmas />} />
            <Route path="historial-llamadas" element={<HistorialLlamadas />} />
            <Route path="log-alarmas" element={<LogAlarmas />} />  {/* 🔹 Nueva Ruta */}

          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
